<template>
  <b-navbar class="header d-print-none app-header justify-content-between">
    <b-nav>
      <b-nav-item>
        <a class="d-md-down-none px-2" href="#" @click="toggleSidebarMethod" id="barsTooltip">
          <i class="la la-bars la-lg" />
        </a>
        <a class="fs-lg d-lg-none" href="#" @click="switchSidebarMethod">
          <i class="la la-bars la-lg" />
        </a>
      </b-nav-item>
    </b-nav>
    <b-nav class="ml-auto flex-nowrap text-right" v-if="userInfo && userInfo.partner">
      <b-nav-item class="partner">
        <b-button variant="link" id="tooltip-grade" class="partner-grade text-primary fw-bold" v-if="userInfo.hasOwnProperty('partnerGrade') && userInfo.partnerGrade === 'GOOD'">
          <i class="good-partner"></i>
          {{ getDefineName('partner', 'gradeData', userInfo.partnerGrade) }}
          <b-tooltip boundary-padding="20" target="tooltip-grade" triggers="hover">
            <p class="mt-md">
              지난 달의 우수 파트너사로 선정되었습니다.<br />
              우수 파트너사는 매월 1일 최근 30일 기준<br />
              서비스불만율이 0.5% 이하이며<br />
              주문 건수가 1,000건 이상인 파트너사를 말합니다.
            </p>
          </b-tooltip>
        </b-button>

        <span>{{ userInfo.partner.partnerName }}</span>
      </b-nav-item>
      <!-- <b-nav-item-dropdown id="v-step-2" class="settingsDropdown logout" no-caret right>
        <template slot="button-content">
          <b-icon icon="gear"></b-icon>
        </template>
        <b-dropdown-divider />
        <b-dropdown-item-button @click="logout"> <i class="la la-sign-out" /> Log Out </b-dropdown-item-button>
        <b-dropdown-item-button> <i class="la la-sign-out" /> 내정보수정 </b-dropdown-item-button>
        <b-dropdown-divider />
      </b-nav-item-dropdown> -->
      <b-nav-item class="logout">
        <b-dropdown variant="link" toggle-class="text-decoration-none p-1" no-caret right>
          <template #button-content>
            <b-icon icon="gear"></b-icon>
          </template>
          <b-dropdown-divider />
          <b-dropdown-item-button class="my-menu" @click="logout"> <i class="la la-sign-out" /> Log Out </b-dropdown-item-button>
          <b-dropdown-item-button class="my-menu" @click="mypage"><i class="la la-sign-out" /> 내정보확인 </b-dropdown-item-button>
        </b-dropdown>
      </b-nav-item>
    </b-nav>
  </b-navbar>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import VueTouch from 'vue-touch'
import { getDefineName } from '@/utils/utils'

export default {
  name: 'Header',
  computed: {
    ...mapState('layout', ['sidebarClose', 'sidebarStatic']),
    ...mapGetters('authentication', ['userInfo']),
    ...mapGetters('common', ['getDefineName'])
  },
  methods: {
    ...mapActions('layout', ['toggleSidebar', 'switchSidebar', 'changeSidebarActive']),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      } else {
        this.switchSidebar(false)
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar()
        this.changeSidebarActive(null)
      } else {
        this.toggleSidebar()
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
    logout() {
      this.$store.dispatch('authentication/logout').then(res => {
        this.$router.push('/login')
      })
    },
    mypage() {
      this.$router.push('/accounts/view')
    }
  }
}
</script>

<style src="./Header.scss" lang="scss" scoped></style>
